export default __webpack_public_path__ + "static/Mont-Bold-03c8c2f6127c1da0fc39d112e642c55f.otf";